import React from 'react';
import PropTypes from 'prop-types';
import nodeIcons from '../constants/nodeIcons';
import nodeDescriptions from '../constants/nodeDescriptions';

const nodeDescriptionsWithIcons = [
    nodeDescriptions.reflight,
    nodeDescriptions.flightCancelled,
];

function shouldShowIcon(description, isLastBagNode) {
    return isLastBagNode || nodeDescriptionsWithIcons.includes(description);
}

function getNodeIcon(description, isLastBagNode) {
    if (nodeIcons[description]) {
        return nodeIcons[description];
    }

    if (isLastBagNode) {
        return nodeIcons.bagIcon;
    }

    return '';
}
export default function NodeIcon(props) {
    const { description, isLastBagNode } = props.node;

    const showIcon = shouldShowIcon(description, isLastBagNode);
    if (!showIcon) {
        return null;
    }

    const nodeIcon = getNodeIcon(description, isLastBagNode);
    return <i className={`station-node__icon ${nodeIcon}`} />;
}

NodeIcon.propTypes = {
    node: PropTypes.instanceOf(Object).isRequired,
};
